export default __webpack_public_path__ + "static/media/sub-topic-model-01.b49e8c91.glb";